import React from 'react'
import { Btn, CustomDataTableHeader } from '../../../../components'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { formatDateToLocale } from '../../../../services/util/date.service'
import './TabHistorico.css'

const formatDateTime = value => {
  if (!value || value === '-') return '-'

  try {
    return formatDateToLocale(value, 'dd/MM/yy HH:mm:ss').toFormat('dd/MM/yy HH:mm:ss')
  } catch (e) {
    return '-'
  }
}

// Valores da coluna deleted_pallet_area.origem (ver DeletedPalletAreaOrigem na API)
const ORIGEM_LABELS = {
  'app:excluir-pallet': 'App – Listagem de Pallets',
  'app:recebimento-estoque:excluir-pallet': 'App – Recebimento Estoque (Pallets)',
  'app:excluir-pallet-alocado': 'App – Pallet alocado (saída avulsa)',
  'app:assoc-caixas': 'App – Associação de caixas',
  'app:ultimo-bip-apagado': 'App – Último bip apagado',
}

const formatOrigem = origem => ORIGEM_LABELS[origem] || origem || '-'

const TabTagsExcluidas = ({ tags }) => {
  const [globalFilter, setGlobalFilter] = React.useState('')

  return (
    <div className="p-grid p-col-12">
      <div className="p-col-12">
        <Btn
          onClick={() => {
            const data = [
              [
                'Horário Exclusão',
                'Tag',
                'Área',
                'Qte Caixas',
                'Status',
                'Criado em',
                'Excluído Por',
                'Código Ativação',
                'Origem',
                'Descrição',
              ],
            ]
            tags.forEach(t => {
              data.push([
                t.horario_exclusao,
                t.pallet_area_id,
                t.area,
                t.qte_caixas,
                t.status,
                t.horario_criacao,
                t.excluido_por,
                t.codigo_ativacao,
                formatOrigem(t.origem),
                t.descricao,
              ])
            })
            gerarArquivoExcel('Tags Excluídas', data, 'tags_excluidas.xlsx')
          }}
        >
          Exportar
        </Btn>
      </div>
      <div className="p-col-12 p-datatable-responsive">
        <DataTable
          value={tags}
          emptyMessage={'Não existem tags excluídas'}
          header={
            <div style={{ width: '100%', height: 50 }}>
              <CustomDataTableHeader onChange={setGlobalFilter} />
            </div>
          }
          globalFilter={globalFilter}
          rows={15}
          paginator={true}
          responsive={true}
        >
          <Column
            field={'horario_exclusao'}
            header={'Horário Exclusão'}
            className="column-responsive"
            style={{ width: '150px' }}
            body={t => formatDateTime(t.horario_exclusao)}
          />
          <Column
            field={'pallet_area_id'}
            header={'Tag'}
            className="column-number column-important"
            style={{ width: '90px' }}
          />
          <Column field={'area'} header={'Área'} className="column-responsive" />
          <Column
            field={'qte_caixas'}
            header={'Qte Caixas'}
            className="column-number"
            style={{ width: '100px' }}
          />
          <Column
            field={'status'}
            header={'Status'}
            className="column-responsive"
            style={{ width: '150px' }}
          />
          <Column
            field={'horario_criacao'}
            header={'Criado em'}
            className="column-responsive"
            style={{ width: '150px' }}
            body={t => formatDateTime(t.horario_criacao)}
          />
          <Column
            field={'excluido_por'}
            header={'Excluído Por'}
            className="column-responsive"
            style={{ width: '180px' }}
          />
          <Column
            field={'codigo_ativacao'}
            header={'Código Ativação'}
            className="column-responsive"
            style={{ width: '150px' }}
          />
          <Column
            field={'origem'}
            header={'Origem'}
            className="column-responsive"
            body={t => formatOrigem(t.origem)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default TabTagsExcluidas
